    <rask-kundorderrad-edit
        [twoRowMode]="true"
        [rootForm]="rootForm"
        [kundorderTyp]="kundorderTyp"
        [kundorder]="kundorder"
        [enableCommands]="enableCommands"
        [kundorderrad]="model"
        [isCreate]="true">
    </rask-kundorderrad-edit>
